import {DG_axios} from "../../../custom/axios";

const baseURL = `/dogoo/common-api-rest/v2.0/employee-references`;
const baseURLNoAccount = `/dogoo/common-api-rest/v2.0/employee-hrm`

export async function getEmployeesNoAccount(filter, page, pageSize, search, sort) {
    const response = await DG_axios.get(baseURLNoAccount, {
            params: {
                filter,
                page,
                pageSize,
                search,
                sort
            }
        }
    )
    return response?.data || []
}

export async function loadEmployeeReferencesApi(filter, page, pageSize, search, sort) {

    const response = await DG_axios.get(baseURL, {
            params: {
                filter,
                page,
                pageSize,
                search,
                sort
            }
        }
    )

    return response?.data || []
}
